import { type FC, Fragment } from 'react'
import { ClientSideTable } from 'Presentation/Components/Table'
import useViewModel from './ViewModel'

const ProjectSaleUsersView: FC = () => {
  const { data, columns } = useViewModel()

  return (
    <Fragment>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title'></div>
          <div className='card-toolbar'></div>
        </div>

        <div className='card-body px-0'>
          <ClientSideTable isGrey pagination columns={columns} data={data} items_per_page={10} />
        </div>
      </div>
    </Fragment>
  )
}

export default ProjectSaleUsersView
